module.exports = __webpack_public_path__ + "img/sec_01.3e082789.jpg";